import '../scss/theme.scss';
// import 'bootstrap';
import './swiper';

import mobileMenu from './utils/hcOffcanvasNav';
import './hcOffcanvasNav-animation';
import lazyload from './utils/lazyload';

// Uncomment if google maps is used in the project
//import { loadGoogleMaps } from './utils/gmap/map';


document.addEventListener('DOMContentLoaded', () => {
  lazyload();
  mobileMenu('#primary-menu', '.hc-menu-toggle');
});
